import { Component } from '@opten/compiler/metadata/component';
import { OnInit } from '@opten/compiler/metadata/lifecycle';
import { hasClass } from '@opten/dom/has-class';
import { showMegaDropdown, hideMegaDropdown } from '../mega-dropdown';
import { lockScrollbar, unlockScrollbar } from '../../utilities/scroll-helper';

const transitionDuration = 700;

@Component({ className: 'js-search' })
export class Search implements OnInit {
    get _isOpen(): boolean {
        return hasClass(this.element, '--show');
    }

    private _backdropElement: HTMLElement;
    private _header: HTMLElement;

    constructor(private element: HTMLElement) {}

    onInit() {
        // todo: own backdrop or resuse navbar?
        this._backdropElement = document.getElementsByClassName(
            'js-search-backdrop'
        )[0] as HTMLElement;

        this._header = document.getElementsByClassName('js-header')[0] as HTMLElement;
        this.updateSearchTop();

        // todo: only add it when open clicked?
        // but how do we remove it, when we close it in the header?
        this._backdropElement.addEventListener('click', () => this.close());
        window.addEventListener('resize', ()=> this.updateSearchTop());
    }

    public toggle() {
        this._isOpen ? this.close() : this.open();
    }

    public updateSearchTop(){
        if (this._header) {
            this.element.style.top = `${Math.round(
                this._header.getBoundingClientRect().height
            )}px`;
        }
    }

    public open() {
        if (this._isOpen) {
            return;
        }

        // mostly for iOS devices
        lockScrollbar(() => {
            // show and then focus search
            showMegaDropdown(this.element, this._backdropElement, () =>
                this.element.getElementsByTagName('input')[0].focus()
            );
        });
    }

    public close() {
        if (!this._isOpen) {
            return;
        }

        // mostly for iOS devices
        unlockScrollbar();

        hideMegaDropdown(this.element, this._backdropElement);
    }
}
